import React from 'react';
import { Package, Info } from 'lucide-react';

const ProductMix = ({ filters }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
      <div className="flex items-center justify-center flex-col text-center py-12">
        <div className="w-16 h-16 bg-pink-50 dark:bg-pink-900/20 rounded-full flex items-center justify-center mb-4">
          <Package className="w-8 h-8 text-pink-500 dark:text-pink-400" />
        </div>
        <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
          Product Mix & Insights
        </h3>
        <p className="text-gray-500 dark:text-gray-400 max-w-md mb-6">
          This feature is coming soon. It will provide detailed analysis of your product mix, 
          category performance, and insights to optimize your menu.
        </p>
        
        <div className="flex items-center p-4 bg-blue-50 dark:bg-blue-900/10 rounded-lg text-blue-600 dark:text-blue-400 text-sm">
          <Info className="w-5 h-5 mr-2" />
          <span>Feature under development</span>
        </div>
      </div>
    </div>
  );
};

export default ProductMix; 